export const appName = 'files';
